import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationSurveyTemplate = createCrudVuexModule({
  persistent: ["selectedEntity"],
  namespaced: true,
  path: "/survey-template",
  options: { localizedFields: ["name", "description", "note"] },

  state: { selectedLibreryQuestionSetId: undefined, selectedLibraryQuestionSet: undefined },
  getters: { selectedLibreryQuestionSetId: (state) => state.selectedLibreryQuestionSetId, selectedLibraryQuestionSet: (state) => state.selectedLibraryQuestionSet },
  mutations: {
    selectedLibreryQuestionSetId: (state, value) => (state.selectedLibreryQuestionSetId = value),
    selectedLibraryQuestionSet: (state, value) => (state.selectedLibraryQuestionSet = value),
  },
  actions: {
    async fetchSelectedQuestionSetDetails({ commit }, id) {
      commit("isLoading", true);
      try {
        const response = await rest.get(`/survey-template/question-set/${id}`);
        commit("selectedLibraryQuestionSet", response.data);
        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/survey-template/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateAdmin({ state, commit }, { surveyTemplate, account }) {
      try {
        const response = await rest.put(`/survey-template/admin`, { id: surveyTemplate._id, accountId: account?._id });

        if (state.selectedEntity) {
          commit("selectedEntity", {
            ...state.selectedEntity,
            admin: account,
          });
        }

        return response;
      } finally {
      }
    },

    async findById({ commit }, id) {
      commit("isLoading", true);
      try {
        commit("selectedEntity", undefined);
        const response = await rest.get(`/survey-template/${id}`);

        commit("selectedEntity", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async fetchOrganizationSurveyTemplate({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        const response = await rest.post(`/survey-template/paginate`, { pagination });
        commit("pagiantion", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async updatePeriod({ commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        return rest.put(`/survey-template/period`, payload);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationSurvey = createCrudVuexModule({
  persistent: ["selectedEntity"],
  namespaced: true,
  path: "/survey",
  options: { localizedFields: ["name", "description", "note"] },

  state: { activeTab: "admin", inProgressSurveyPagination: undefined, complatedSurveyPagination: undefined, resultsPagination: undefined },

  getters: {
    activeTab: (state) => state.activeTab,
    inProgressSurveyPagination: (state) => state.inProgressSurveyPagination,
    complatedSurveyPagination: (state) => state.complatedSurveyPagination,
    resultsPagination: (state) => state.resultsPagination,
  },
  mutations: {
    activeTab: (state, value) => (state.activeTab = value),
    inProgressSurveyPagination: (state, value) => (state.inProgressSurveyPagination = value),
    complatedSurveyPagination: (state, value) => (state.complatedSurveyPagination = value),
    resultsPagination: (state, value) => (state.resultsPagination = value),
  },
  actions: {
    async fetchInProgressSurveys({ getters, commit, dispatch }, { pagination, templateId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "IN_PROGRESS", isObject: true } } };
        const response = await rest.post(`/survey/paginateWith`, { pagination: payload, id: templateId });
        commit("inProgressSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async fetchComplatedSurveys({ getters, commit, dispatch }, { pagination, templateId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "DONE", isObject: true } } };
        const response = await rest.post(`/survey/paginateWith`, { pagination: payload, id: templateId });
        commit("complatedSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchResults({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/survey/${id}/results`);
        commit("resultsPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async completeSurvey({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/survey/${id}/complete`);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationSurveyItem = createCrudVuexModule({
  namespaced: true,
  path: "/survey-item",
  options: { localizedFields: ["name", "description", "unit", "title", "note"] },

  state: { memberPagination: undefined, editedMember: undefined },

  getters: { memberPagination: (state) => state.memberPagination, editedMember: (state) => state.editedMember },
  mutations: { memberPagination: (state, value) => (state.memberPagination = value), editedMember: (state, value) => (state.editedMember = value) },
  actions: {
    async save({ dispatch }, payload) {
      const participant = await dispatch("preparePayload", {
        editedEntity: {},
        form: { ...payload.participant },
      });

      payload.participant = participant;
      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    async fetchMembers({ getters, commit, dispatch }, pagination) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/survey-item/member/paginate`, { pagination });
        commit("memberPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async saveMember({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const participant = await dispatch("preparePayload", {
          editedEntity: {},
          form: { ...payload.participant },
        });
        payload.participant = participant;
        let response;

        if (payload && payload._id) {
          response = await rest.put(`/survey-item/member`, { item: { _id: payload._id, participant: payload.participant } });
        } else {
          response = await rest.post(`/survey-item`, { item: payload });
        }

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async deleteMember({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        await rest.delete(`/survey-item/member/${id}`);
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateStatus({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/survey-item/status`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
